"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCaddies = void 0;
const calculateCaddies = (golf_line) => {
    let val = 0;
    if (!golf_line)
        return val;
    if (!golf_line?.caddies)
        return val;
    if (!golf_line?.caddies?.total)
        return val;
    // Caddies
    if (golf_line?.caddies?.enabled &&
        golf_line?.caddies?.payment_option !== null
    //&& golf_line?.caddies?.payment_option === "ON_ARRIVAL"
    ) {
        val += golf_line?.caddies?.total;
    }
    return val;
};
exports.calculateCaddies = calculateCaddies;
